/*
 * @Author: Scherger
 * @Date: 2018-11-28 10:00:32
 * @Last Modified by: Scherger
 * @Last Modified time: 2019-10-22 16:56:37
 */
import goFun from "@/utils/cc-webapp/navigator.js";
import utilsFun from "@/utils/utils.js";
import TOAST from "@/utils/vant.js";

import { Dialog } from 'vant';
import router from '../../router'

import {
  SERVER
} from "@/api/apiConfig.js";

// var w_session = 'cd3468cae1244d7cbb5db1ac021b09b6' //启帆
//var w_session = 'e9f452f40550471093aa8d94b6573475' //漫漫账号
// var w_session = '849371B8B26EA7869A12FCF9E53CC43442E972E4E0692834'
// var w_session = 'AC015C84CC77DE0F1AE767741C7EDE97BC2FFC5331E1C4F8' //皇璋
// var w_session = '4E36A0B0F86A159A278CE1484B0DECD2' //is me 开发
// var w_session = 'E134D54392D485F46B1F501B92548615' //is me 灰度
const w_session = 'A571DB11466F79ACA7C03192FAD85BB804B1AC6017A728C8'
// var w_session = '35B645E0996C41FC3D1D878856566EA4555ADEAAF81A5BC4'//liyeyu test
// var w_session = '909BD947BAD32CA24EA0DB848994420528D02F889E51230A'

var clientType = 'android' //用戶使用的設備類型，

var dev = SERVER.DEV


/** get 不支持router跳转，只能在客户端上使用
 *
 *  @param  {boolean} loginFlag  是否需要跳转登录页， true / false
 *
 * @Examples
 * 此方法只负责获取 session , 不校验
 * @Examples
 * 没有session默认打开新窗口进入登录页
 *
 * @Examples
 * loginFlag
 * true 为跳转
 * false 为返回空
 *
 */

function get(loginFlag) {

  return new Promise((resolve, reject) => {
    if (dev) {
      resolve({
        session: w_session,
      })
      return
    }

    this.getSession().then(session => {
      if (session) {

        let sessionData = JSON.parse(session)
        resolve({
          session: sessionData.session,
          userId: sessionData.userId,
          userType: sessionData.userType || null,
          userInfo: sessionData.userInfo || null,
        })

      } else { //本地没有session

        //检查是否需要跳转首页
        console.log('login', loginFlag)
        if (loginFlag) {
          router.push({
            path: "/login"
          })
          reject('no session')

        } else {
          resolve({
            session: null,
          })
        }

      }

    })
  })

}

/**
 * 打开登录界面
 *
 */
function go() {
  let obj = {
    path: utilsFun.splitUrl('login'),
    isTransWindows: true, //登錄頁改爲沉浸式打開
  }
  goFun.openTo(obj)
}



/** 检查登录状态 支持router形式
 * @param  {string} gotoPage 跳转页面参数
 * @Example
 * expireAt //三个月失效
 * @Example
 * gotoPage
 *
 *  let gotoPage = {
      router: this.$router, //默认跳首页没有 router
      path: url,  //跳转的url参数 默认跳首页
    }
 *
 *
 */
function check(Page) {

  var GotoData = ''

  if (Page) {
    GotoData = Page
  } else {

    let url = utilsFun.splitUrl('login')

    GotoData = {
      path: url,
      isTransWindows: true, //登錄頁改爲沉浸式打開
      params: {
        text: '这是参数123'
      }
    };

  }

  return new Promise((resolve, reject) => {

    if (dev) {
      resolve(w_session)
      return
    }

    this.getSession().then(session => {
      if (session) {

        let data = JSON.parse(session)
        let etime = data.expireAt
        let toDayTime = new Date().getTime()
        // let toDayTime = new Date().getTime() + 30000000000
        if (toDayTime < etime) {
          // console.log('未过期')

          resolve(data)

        } else {

          // console.log('过期');
          goFun.openTo(GotoData)

        }

      } else {
        //没有session

        goFun.openTo(GotoData)

      }

    })
  })

}

/** 关闭登录页面
 */
function closeLogin() {
  let obj = {
    backPage: 'login'
  }
  goFun.closeW(obj)


}

/** 将session存储到本地中 (异步)
 * @param  {String} data 缓存的登录数据
 */
function setSession(data) {
  return new Promise((resolve, reject) => {
    // localStorage.setItem('app_session', JSON.stringify(data));
    saveLoginSession(data);
    //console.log("setSession", localStorage.getItem('app_session'));
    resolve(data)
  })
}


/** 从本地缓存中同步获取session
 * @returns 返回缓存的登录数据，无则返回 false
 */
function getSession() {

  return new Promise((resolve, reject) => {
    //var dataValue = native.getStorage('app_session');
    var dataValue = localStorage.getItem('app_session');
    // console.log("本地缓存 app_session ", dataValue);

    if (dataValue) {
      resolve(dataValue)

    } else {
      resolve(false)
    }
  })

}

/** 退出登錄
 *
 */
function returnLogin() {
  TOAST.text("正在退出當前帳號！");
  localStorage.removeItem('app_session');
  TOAST.text("成功退出當前帳號！");
}

/** 保存登录信息
 *
 */
function saveLoginSession(obj) {
  localStorage.setItem('app_session', JSON.stringify(obj));
}

export default {
  go,
  get,
  check,
  getSession,
  setSession,
  closeLogin,
  returnLogin,
  w_session,
  saveLoginSession,
}



// WEBPACK FOOTER //
// ./src/utils/cc-webapp/login.js